<template>
  <div class="goalButtons" :class="`-${type}`">
    <slot></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: 'GoalButtons',

  props: {
    type: {
      type: String,
      default: 'fix'
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.goalButtons {
  display: flex;
  justify-content: center;
  margin: 45px -16px 0;
  padding: 10px 8px;
  background-color: #f5f5f5;

  &.-contents {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 30px;
  }

  &.-fix {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 10px;
    margin: 0;
    z-index: 1;

    @include mixins.media() {
      padding: 16px;
    }
  }
}

::v-deep .button {
  flex-grow: 1;
  flex-shrink: 1;
  max-width: 167px;
  margin: 5px;
  padding-left: 0;
  padding-right: 0;
}
</style>
